import { useCallback } from 'react'
import { useCreateCampaignContext } from '../../context'
import { CampaignTypeEnum } from 'app/api/marketing/discount-campaign/model'
import {
  BuyOneGetOneTypeLayout,
  TotalBillTypeLayout,
  TreatmentTypeLayout,
  BundleTypeLayout,
} from './layouts'

export const ContentLayout = () => {
  const { campaignType } = useCreateCampaignContext()

  const renderContent = useCallback(() => {
    switch (campaignType) {
      case CampaignTypeEnum.Treatments:
        return <TreatmentTypeLayout />
      case CampaignTypeEnum.Voucher:
        return null
      case CampaignTypeEnum.BuyOneGetOne:
        return <BuyOneGetOneTypeLayout />
      case CampaignTypeEnum.Bundle:
        return <BundleTypeLayout />
      case CampaignTypeEnum.TotalBill:
        return <TotalBillTypeLayout />
      default:
        return null
    }
  }, [campaignType])()

  return <>{renderContent}</>
}
